import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[uiAutocompletePostfixIcon]',
})
export class AutocompletePostfixIconDirective {
  templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
